import { render } from "./DefaultComponent.vue?vue&type=template&id=5dcb4c7c"
import script from "./DefaultComponent.vue?vue&type=script&lang=js"
export * from "./DefaultComponent.vue?vue&type=script&lang=js"

import "./DefaultComponent.vue?vue&type=style&index=0&id=5dcb4c7c&lang=scss"
script.render = render

export default script